

















































































import { Vue, Component, PropSync } from 'vue-property-decorator';
import ThirtyDaysNoticeSummaryViewModel from '@/vue-app/view-models/components/flagship/flagship-link-goals/thirthy-days-notice/thirty-days-notice-summary-view-model';

@Component({ name: 'ThirtyDaysSummaryNotice' })
export default class ThirtyDaysSummaryNotice extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  is_open!: boolean;

  @PropSync('investorGoalId', { type: String, required: true })
  investor_goal_id!: string;

  @PropSync('investmentGoalTypeId', { type: String, required: true })
  investment_goal_type_id!: string;

  @PropSync('term', { type: Number, required: true })
  term_synced!: number;

  @PropSync('goalName', { type: String, required: true })
  goal_name!: string;

  @PropSync('targetAmount', { type: String, required: true })
  target_amount!: string;

  @PropSync('monthlyContribution', { type: String, required: true })
  monthly_contribution!: string;

  @PropSync('targetDate', { type: String, required: true })
  target_date!: string;

  view_model = Vue.observable(new ThirtyDaysNoticeSummaryViewModel(this))

  closeDialog() {
    this.is_open = false;
  }

  back() {
    this.view_model.back();
    this.closeDialog();
  }

  async save() {
    if (await this.view_model.updateInvestorGoalDates(
      this.investor_goal_id, this.investment_goal_type_id, this.term_synced,
    )) {
      this.closeDialog();
    }
  }
}
